import {Box3, ExtrudeGeometry, Mesh, Path, Shape, Vector3} from "three";
import {signedPolygonArea} from "./mathUtils";
import {previewMaterial} from "../constants/materialConstants";

export function createShapeFromPoints(points) {
    const shape = new Shape();

    let point1 = points[0];
    shape.moveTo(point1.x, point1.z);
    for (let i = 1; i < points.length; i++) {
        let p = points[i];
        shape.lineTo(p.x, p.z);
    }

    return shape;
}

export function createShapeFromFacePoints(points) {
    const shape = new Shape();


    let point1 = points[0];
    shape.moveTo(point1[0], point1[1]);
    for (let i = 1; i < points.length; i++) {
        let p = points[i];
        shape.lineTo(p[0], p[1]);
    }
    return shape;
}

export function createMeshFromShape(shape, options = {}, material = previewMaterial) {
    let extrudeSettings = {depth: 1.5, bevelEnabled: false};
    if (!$.isEmptyObject(options)) {
        extrudeSettings = options;
    }
    const geometry = new ExtrudeGeometry(shape, extrudeSettings);
    const mesh = new Mesh(geometry, material);
    mesh.rotateX(Math.PI / 2);
    return mesh;
}

export function createMeshFromPoints(points) {
    let shape = createShapeFromPoints(points);
    return createMeshFromShape(shape);
}

export function createPathFromPoints(points) {
    let path = new Path();
    //path.autoClose = true;
    path.moveTo(points[0].x, points[0].z);
    for (let i = 1; i < points.length; i++) {
        let p = points[i];
        path.lineTo(p.x, p.z);
    }
    path.closePath();
    return path;
}

export function pathPointsClockwise(points) {
    return signedPolygonArea(points) < 0;
}

export function shapeContainsPoints(shape, point) {
    let polygonPoints = shape.getPoints();

    let inside = false;
    for (let i = 0, j = polygonPoints.length - 1; i < polygonPoints.length; j = i++) {
        let xi = polygonPoints[i].x, yi = polygonPoints[i].y;
        let xj = polygonPoints[j].x, yj = polygonPoints[j].y;

        let intersect = ((yi > point.y) !== (yj > point.y)) && (point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi);
        if (intersect) {
            inside = !inside;
        }
    }

    return inside;
}

export function getMeshWithHoleFromShape(shape, holePoints, rotate) {
    //Add hole to shape
    let holePath = createPathFromPoints(holePoints);
    shape.holes.push(holePath);

    //Mesh erstellen
    let mesh = createMeshFromShape(shape);

    if (rotate) {
        mesh.rotateZ(Math.PI / 2);
    }

    //Zentrierung des Meshes im Ursprung
    let bounds = new Box3().setFromObject(mesh);
    let centerVector = bounds.getCenter(new Vector3());
    centerVector.multiplyScalar(-1);
    mesh.position.set(centerVector.x, centerVector.y * 0.5, centerVector.z);
    return mesh;
}
